import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import XIcon from '@mui/icons-material/X';

const SeniorBingoLuncheon = () => {
  return (
    <Box
      sx={{
        p: { xs: 2, md: 4 },
        backgroundColor: '#fff',
        minHeight: '100vh',
        maxWidth: 900,
        mx: 'auto',
      }}
    >
      <Typography variant="h3" gutterBottom>
        Vision Zero Outreach at the Miami Lakes Senior Bingo Luncheon
      </Typography>

      <Typography paragraph>
        On Thursday, September 18, the Town of Miami Lakes joined the Elder Affairs Committee of
        Miami Lakes, at the Senior Bingo Luncheon for the second time to promote its Vision Zero
        initiative: a commitment to eliminating traffic-related fatalities and serious injuries
        within the community.
      </Typography>

      {/* Photo 1 */}
      <Box sx={{ my: 3 }}>
        <Box
          component="img"
          src={`${process.env.PUBLIC_URL}/images/news-senior-bingo-luncheon-event2.jpg`}
          alt="Seniors before the Bingo Event filling out Vision Zero Surveys"
          sx={{ width: '100%', borderRadius: 2 }}
        />
        <Typography variant="caption" display="block" align="center" sx={{ mt: 1 }}>
          Seniors before the Bingo Event filling out Vision Zero Surveys.
        </Typography>
      </Box>

      <Typography paragraph>
        At the event, the Town collected over 40 public surveys, providing valuable insights into
        community priorities. Seniors at the event were also able to mark areas in the town they
        felt were unsafe and engaged in active conversations with town staff.
      </Typography>

      {/* Photo 2 */}
      <Box sx={{ my: 3 }}>
        <Box
          component="img"
          src={`${process.env.PUBLIC_URL}/images/news-senior-bingo-luncheon-event3.jpg`}
          alt="A member of the Elder Affairs Committee marking areas of concern on a town map"
          sx={{ width: '100%', borderRadius: 2 }}
        />
        <Typography variant="caption" display="block" align="center" sx={{ mt: 1 }}>
          A member of the Elder Affairs Committee marking areas of concern on a town map.
        </Typography>
      </Box>

      <Typography paragraph>
        Attendees enjoyed a lively afternoon of bingo, and a delicious lunch. The event created a
        welcoming space for residents to share their perspectives while connecting with neighbors.
      </Typography>

      {/* Photo 3 */}
      <Box sx={{ my: 3 }}>
        <Box
          component="img"
          src={`${process.env.PUBLIC_URL}/images/news-senior-bingo-luncheon-event4.jpg`}
          alt="Seniors playing bingo at the luncheon"
          sx={{ width: '100%', borderRadius: 2 }}
        />
        <Typography variant="caption" display="block" align="center" sx={{ mt: 1 }}>
          Seniors playing bingo at the luncheon.
        </Typography>
      </Box>

      <Typography paragraph>
        To wrap up the day, the Town hosted a raffle, awarding three Vision Zero shirts as a token
        of appreciation for participants’ engagement. The raffle added an extra layer of excitement,
        leaving attendees eager to complete surveys and share their valuable input on making Miami
        Lakes safer.
      </Typography>

      {/* Photo 4 */}
      <Box sx={{ my: 3 }}>
        <Box
          component="img"
          src={`${process.env.PUBLIC_URL}/images/news-senior-bingo-luncheon-event5.jpg`}
          alt="The Vision Zero Team at the Senior Bingo Luncheon"
          sx={{ width: '100%', borderRadius: 2 }}
        />
        <Typography variant="caption" display="block" align="center" sx={{ mt: 1 }}>
          The Vision Zero Team at the Senior Bingo Luncheon.
        </Typography>
      </Box>

      <Typography paragraph>
        We invite you to continue participating as this public engagement effort just started. Join
        the conversation through our social media channels.
      </Typography>

      {/* Social Media Links */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mb: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <InstagramIcon color="action" />
          <Link
            href="https://www.instagram.com/miamilakesvisionzero"
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            color="inherit"
            sx={{ fontWeight: 500 }}
          >
            @miamilakesvisionzero
          </Link>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <XIcon color="action" />
          <Link
            href="https://twitter.com/miamilakesvz"
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            color="inherit"
            sx={{ fontWeight: 500 }}
          >
            @miamilakesvz
          </Link>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <FacebookIcon color="action" />
          <Link
            href="https://www.facebook.com/share/1HS7Sy2A9Z/?mibextid=wwXIfr"
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            color="inherit"
            sx={{ fontWeight: 500 }}
          >
            Vision Zero Miami Lakes
          </Link>
        </Box>
      </Box>

      <Typography paragraph>
        Be part of the conversation and participate by completing the community survey using{' '}
        <Link href="https://arcg.is/04zv1u0" target="_blank" rel="noopener">
          this survey link
        </Link>
        .
      </Typography>

      <Typography paragraph>
        Our website and social media channel continue posting project updates and upcoming events.
      </Typography>

      <Typography paragraph>
        Para español:{' '}
        <Link href="https://arcg.is/04zv1u0" target="_blank" rel="noopener">
          haga clic aquí
        </Link>{' '}
        (seleccione español)
      </Typography>
    </Box>
  );
};

export default SeniorBingoLuncheon;
